import { render, staticRenderFns } from "./PetHeader.vue?vue&type=template&id=0c857412&"
import script from "./PetHeader.vue?vue&type=script&lang=js&"
export * from "./PetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports